import { HOUR_IN_MILLISECONDS } from 'config';
import {
  MineModelDto,
  ProjectDto,
  useMineModelQuery,
  useProjectQuery
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { CustomReportsPageParams } from './constants';

export type CustomReportsPageQueries = [
  UseQueryResult<ProjectDto>,
  UseQueryResult<MineModelDto | undefined>,
];

const useCustomReportsPageQueries = (params: CustomReportsPageParams): CustomReportsPageQueries => [
  useProjectQuery(params.projectId, {
    staleTime: HOUR_IN_MILLISECONDS,
  }),
  useMineModelQuery({ mineModelId: params.projectId }, {
    staleTime: HOUR_IN_MILLISECONDS,
  }),
];

export default useCustomReportsPageQueries;
